export default {
  LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
};
